import lazyPage from "../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Cookie/Cookie.tsx",
    () => import("./Cookie"),
);
